export const createServiceAvailability = `mutation createServiceAvailability($input: CreateServiceAvailabilityRequest!) {
  createServiceAvailability(input: $input) {
    pkId
    version
    region
    businessGroup
    productFamily
    productGroup
    productDesc
    productLine
    country
    businessModel
    choiceId
    localization
    startDate
    endDate
    status
    wwAutoStartDate
    wwAutoEndDate
    comments
    apRegion
    euRegion
    naRegion
    laRegion
    material
    regionLock
    countryDesc
    materialDesc
    whoChanged
    createDate
    lastModifiedDate
    message
  }
}`